import { ChatType } from '../../enums/ChatType';
import React from 'react';

/**
 * INTERFACE: ChatTabsProps
 * Defines props for ChatTabs component
 * PROPERTIES:
 * - languageCode: Translation strings for default labels
 * - activeTab: Which tab is currently selected
 * - onTabChange: Function to call when tab clicked
 * - dmTabName: Custom name for DM tab (from parent app config)
 * - eventChatName: Custom name for EventChat tab (from parent app config)
 */
interface ChatTabsProps {
    languageCode: string;
    activeTab: ChatType;
    onTabChange: (tab: ChatType) => void;
    dmTabName: string;
    eventChatName: string;
}

const ChatTabs = ({ activeTab, onTabChange, languageCode, dmTabName, eventChatName }: ChatTabsProps) => {
    /**
     * Two button tabs side by side
     * DM TAB:
     * - Shows dmTabName if provided, else translated "DMs"
     * - Active when activeTab === ChatType.DM
     * - onClick switches to DM tab
     * EVENTCHAT TAB:
     * - Shows eventChatName if provided, else translated "EventChat"
     * - Converts to uppercase for emphasis
     * - Active when activeTab === ChatType.EventChat
     * - onClick switches to EventChat tab
     */
    return (
      <div className="tab-container">
        {/* DM Tab Button */}
        <button
          className={`tab-button ${activeTab === ChatType.DM ? "active" : ""}`}
          onClick={() => onTabChange(ChatType.DM)}
        >
          {dmTabName || languageCode['DMs']}
        </button>
        
        {/* EventChat Tab Button */}
        <button
          className={`tab-button ${activeTab === ChatType.EventChat ? "active" : ""}`}
          onClick={() => onTabChange(ChatType.EventChat)}
        >
          {(eventChatName || languageCode['EventChat']).toUpperCase()}
        </button>
      </div>
    );
  };
  

export default ChatTabs;
